export default {
  initial_day: 'A partir de esta fecha aplicará el nuevo salario.',
  end_day: 'Hasta esta fecha aplicará el nuevo salario.',
  category:
    'A partir del “salario base” se liquidara la nomina. Esta será la base tenida en cuenta para la liquidación de la seguridad social y parafiscales.',
  base_salary:
    'Esta será la base mensual para liquidar tus pagos según la frecuencia de pago de la compañía. Si es Integral Mensual: ingresa la totalidad del salario base (incluyendo el factor prestacional); si es Mensual - medio tiempo: ingresa el valor real que va a devengar mensualmente.',
}
